import React, { ComponentType, CSSProperties, useContext } from 'react';
import { ContentEditableType } from '@/constants';

export interface EditableProps {
	idx: string;
	type: ContentEditableType;
	tag: string;
	attributes: Record<string, string>;
	style?: CSSProperties;
	html: string;
}

export interface EditableRendererContextValue {
	Editable?: ComponentType<EditableProps>;
}

const EditableRendererContext = React.createContext<EditableRendererContextValue>({});

// The editor package must not import tiptap, so the layout injects the
// tiptap-backed component through this context.
export function EditableRendererProvider({
	Editable,
	children,
}: {
	Editable?: ComponentType<EditableProps>;
	children?: React.ReactNode;
}) {
	const value = React.useMemo(() => ({ Editable }), [Editable]);
	return (
		<EditableRendererContext.Provider value={value}>
			{children}
		</EditableRendererContext.Provider>
	);
}

export function useEditableRenderer() {
	return useContext(EditableRendererContext);
}
